export default {
  dataComputerApi: {
    dataList: '/api/dataComputerApi/dataList',
    delData: '/api/dataComputerApi/delData',
    personList: '/api/dataComputerApi/personList',
    delPerson: '/api/dataComputerApi/delPerson',
    downloadTemp: '/api/dataComputerApi/downloadTemp',
    importData: '/api/dataComputerApi/importData',
    importPersonData: '/api/dataComputerApi/importPersonData',
  },
  dataCityBasicApi: {
    getList: '/api/dataCityBasic/getList',
    saveOrUpdate: '/api/dataCityBasic/saveOrUpdate',
    del: '/api/dataCityBasic/del',
  },
}